const SPECIAL: Record<string, number> = {
    Backspace:  0xFF08,
    Tab:        0xFF09,
    Enter:      0xFF0D,
    Escape:     0xFF1B,
    Delete:     0xFFFF,
    Home:       0xFF50,
    ArrowLeft:  0xFF51,
    ArrowUp:    0xFF52,
    ArrowRight: 0xFF53,
    ArrowDown:  0xFF54,
    PageUp:     0xFF55,
    PageDown:   0xFF56,
    End:        0xFF57,
    Insert:     0xFF63,
    F1:  0xFFBE, F2:  0xFFBF, F3:  0xFFC0, F4:  0xFFC1,
    F5:  0xFFC2, F6:  0xFFC3, F7:  0xFFC4, F8:  0xFFC5,
    F9:  0xFFC6, F10: 0xFFC7, F11: 0xFFC8, F12: 0xFFC9,
    CapsLock: 0xFFE5,
    " ":     0x0020,
};

export function keyToKeysym(e: KeyboardEvent): number {
    if (e.key === "Shift")   return e.location === 2 ? 0xFFE2 : 0xFFE1;
    if (e.key === "Control") return e.location === 2 ? 0xFFE4 : 0xFFE3;
    if (e.key === "Alt")     return e.location === 2 ? 0xFFEA : 0xFFE9;
    if (e.key === "Meta")    return 0xFFEB;
    if (SPECIAL[e.key] !== undefined) return SPECIAL[e.key];
    if (e.key.length === 1) {
        const cp = e.key.codePointAt(0)!;
        return cp > 0xFFFF ? 0x01000000 | cp : cp;
    }
    return 0;
}
